import {Sked, SkedContext} from 'src/app/current-sked/shared/model/sked';
import {CSChallengeCycle, CSChallengeCycleDay, CSChartDetail, CurrentSkedChallenge} from '../../model/project';
import {CurrentSkedTask} from '../../model/task';

export interface MetricFormValue {
  metricId: string;
  value: string;
  readOnly: boolean;
}

export interface SubtaskFormState {
  formValues: MetricFormValue[];
  timestamp?: string;
}

export interface CurrentSkedState {
  skedContext: SkedContext;
  currentSked: Record<string, Sked>; // 'today' or 'expired'
  currentSkedProjectsMap: Record<string, Record<string, Sked>>; // projectId -> ('today' or 'expired') -> Sked
  task: CurrentSkedTask;
  updatedTask: CurrentSkedTask;
  // When updating a boolean metric value in the current sked, the initial displayed value is null. only after a selection is made does the value show, thus keeping track of which values have been touched is needed
  metricUpdateValueChosenMap: Record<string, boolean>; // key is the metric id
  // Store form state for each task/subtask combination
  metricFormStateMap: Record<string, Record<string, SubtaskFormState>>; // key is taskId, value is Record<subtaskId, SubtaskFormState>
  challengeMap: Record<string, CurrentSkedChallenge>; // challengeId -> challenge
  challengeDaysMap: Record<string, Record<string, CSChallengeCycleDay>>; // challengeId -> (dateKey -> day)
  challengeCyclesMap: Record<string, Record<string, CSChallengeCycle>>; // challengeId -> (cycleId -> cycle)
  chartDetailMap: Record<string, Record<string, CSChartDetail>>; // dateKey -> (metricId -> detail)
  chartDetailLoadingMap: Record<string, Record<string, boolean>>; // dateKey -> (metricId -> loading)
}

export const initialCurrentSkedState: CurrentSkedState = {
  skedContext: {type: 'sked', projectId: '', preventGetSkedData: false, filter: 'today'},
  currentSked: {},
  currentSkedProjectsMap: {},
  task: null,
  updatedTask: {} as CurrentSkedTask,
  metricUpdateValueChosenMap: {},
  metricFormStateMap: {},
  challengeMap: {},
  challengeDaysMap: {},
  challengeCyclesMap: {},
  chartDetailMap: {},
  chartDetailLoadingMap: {},
};
